const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  data() {
    return {
      user: {
        phone: '',
        password: '',
        passwordConfirm: '',
      },
      type: 'sms_profile',
      code: '',
      sentCode: false,
      email_redirect: false,
      token: null,
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
    };
  },
  computed: {
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    phoneMask() {
      const masks = {
        russia8: '8 (###) ###-####',
        russia7: '+7 (###) ###-####',
        belarus: '+375 (##) ###-####',
      };

      // eslint-disable-next-line no-unused-vars
      const russia7Regex = /^\+?7/; // Номера РФ начинаются с 7
      const russia8Regex = /^8/; // Номера РФ начинаются с 8
      const belarusRegex = /^\+?37?5?/; // Номера Беларуси начинаются с 375

      if (russia8Regex.test(this.user.phone)) {
        return masks.russia8;
      }
      if (belarusRegex.test(this.user.phone)) {
        return masks.belarus;
      }

      return masks.russia7;
    },
  },
  created() {
    // this.Focus('remindPhone');
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
  },
  methods: {
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    Reset() {
      this.user = {
        phone: '',
        password: '',
        passwordConfirm: '',
      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.Focus('remindEmail');
    },
    Back() {
      this.Reset();
      this.$router.push('/');
    },
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const dataRequest = { type: app.type };
      if (this.email_redirect) {
        dataRequest.email = app.user.email;
      } else {
        url = 'profiles/api/register/get-sms';
        dataRequest.phone = app.user.phone;
      }

      app.$store.getters.axl.post(url, dataRequest)
        .then(({ data }) => {
          if (!data.email_redirect) {
            app.sentCode = true;
            app.Focus('remindCode');
          } else {
            this.$nextTick(() => {
              app.email_redirect = data.email_redirect;
              app.type = 'email_profile';
            });
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);

          if (app.email_redirect) {
            app.Focus('remindEmail');
          } else {
            app.Focus('remindPhone');
          }
        });
    },
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (this.email_redirect) {
        data.email = app.user.email;
      } else {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }

      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          // app.Focus('regLastName');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('remindCode');
        });
    },
    Remind() {
      const app = this;
      const formData = app.user;
      formData.token = app.token;
      formData.type = app.type;

      let url = 'api/remind';
      if (this.email_redirect) {
        url = 'api/remind/email';
      }

      app.$store.getters.axl.post(url, formData)
        .then((response) => {
          app.Reset();
          app.$store.dispatch('ShowInfo', response.data.msg);
          app.$router.push('/');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
};
